import React, { useMemo } from 'react';

function BlackHoleEmbed() {
  const hasWebGPU = useMemo(() => {
    return typeof window !== 'undefined' && typeof navigator !== 'undefined' && !!navigator.gpu;
  }, []);

  return (
    <div className="App-logo">
      {hasWebGPU ? (
        <iframe
          title="WebGPU Black Hole"
          src="/blackhole/index.html"
          className="blackhole-iframe"
          loading="lazy"
        />
      ) : (
        <div className="blackhole-shell">
          <div className="blackhole-core" />
        </div>
      )}
    </div>
  );
}

export default BlackHoleEmbed;
